<template>
  <div id="fr">
    <LanguageMenu />
    <Home />
    <Infos />
    <Staff />
    <Philosophy />
    <ServicesHome/>
    <ServicesRDV />
    <ContactUs />
    <Order />
  </div>
</template>

<script>
import LanguageMenu from './En/LanguageMenu.vue'
import Home from './En/Home.vue'
import Philosophy from './En/Philosophy.vue'
import Infos from './En/Infos.vue'
import Staff from './En/Staff.vue'
import ServicesHome from './En/ServicesHome.vue'
import ServicesRDV from './En/ServicesRDV.vue'
import ContactUs from './En/ContactUs.vue'
import Order from './En/Order.vue'

export default {
  name: 'en',
  components: {
    LanguageMenu,
    Home,
    Infos,
    Staff,
    Philosophy,
    ServicesHome,
    ServicesRDV,
    ContactUs,
    Order,
  }
}
</script>



// WEBPACK FOOTER //
// En.vue?0762caa6